document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".slider--container").forEach((sliderContainer) => {
        const sliderWrapper = sliderContainer.querySelector(".slider__products--wrapper");
        const prevButton = sliderContainer.querySelector(".swiper-button.prev");
        const nextButton = sliderContainer.querySelector(".swiper-button.next");
        const dots = sliderContainer.querySelectorAll(".slider-dot");
        const productCards = sliderContainer.querySelectorAll(".product-card");

        if (!sliderWrapper || productCards.length === 0) return; // Exit if no products

        let currentIndex = 0;
        const gap = parseInt(getComputedStyle(sliderWrapper).gap) || 20;

        // Determine if the user is on mobile
        function isMobile() {
            return window.innerWidth <= 768;
        }

        function getScrollAmount() {
            return isMobile() ? sliderWrapper.offsetWidth : productCards[0].offsetWidth + gap;
        }

        function updateSlider() {
            const scrollAmount = getScrollAmount();
            sliderWrapper.scrollTo({
                left: currentIndex * scrollAmount,
                behavior: "smooth"
            });

            // Hide prev button if at the first product
            if (prevButton) prevButton.style.display = currentIndex === 0 ? "none" : "flex";

            // Hide next button if at the last product
            if (nextButton) nextButton.style.display = currentIndex >= productCards.length - 1 ? "none" : "flex";

            // Update active dot
            dots.forEach((dot, index) => {
                dot.classList.toggle("active", index === Math.floor(currentIndex / (isMobile() ? 2 : 1)));
            });
        }

        // Initial state
        updateSlider();

        if (nextButton) {
            nextButton.addEventListener("click", function () {
                if (currentIndex < productCards.length - 1) {
                    currentIndex++;
                    updateSlider();
                }
            });
        }

        if (prevButton) {
            prevButton.addEventListener("click", function () {
                if (currentIndex > 0) {
                    currentIndex--;
                    updateSlider();
                }
            });
        }

        // Dot navigation (handling mobile and desktop separately)
        dots.forEach((dot, index) => {
            dot.addEventListener("click", function () {
                if (isMobile()) {
                    currentIndex = index * 2;
                    if (currentIndex >= productCards.length) {
                        currentIndex = productCards.length - 1;
                    }
                } else {
                    currentIndex = index;
                }
                updateSlider();
            });
        });

        // Update dots on manual scroll
        sliderWrapper.addEventListener("scroll", function () {
            const scrollLeft = sliderWrapper.scrollLeft;
            const scrollAmount = getScrollAmount();
            currentIndex = Math.round(scrollLeft / scrollAmount);
            dots.forEach((dot, index) => {
                dot.classList.toggle("active", index === Math.floor(currentIndex / (isMobile() ? 2 : 1)));
            });
        });
    });
});
